import { isEmpty } from 'lodash-es';
import { type SystemPrivilege } from './constants';
// eslint-disable-next-line @conarti/feature-sliced/layers-slices
import { userStore } from '@/entities/user/@x/authentication';

export function checkUserPrivileges(
  requiredPrivileges: SystemPrivilege[],
  strict?: boolean,
) {
  const userPrivileges = userStore.state?.privileges ?? [];

  if (isEmpty(requiredPrivileges)) {
    return false;
  }

  if (strict) {
    return requiredPrivileges.every(privilege =>
      userPrivileges.includes(privilege),
    );
  }

  return requiredPrivileges.some(privilege =>
    userPrivileges.includes(privilege),
  );
}
